<template>
	<div v-html="selectedVariant.descriptionHtml"></div>
</template>
<script setup>
import { storeToRefs } from 'pinia'

import { useProductStore } from '@stores'

const store = useProductStore()
const { selectedVariant } = storeToRefs(store)
</script>
